import { Col, Row } from 'react-bootstrap';
import { ReactComponent as MailIcon } from '../../../assets/icons/mailSmall.svg';
import styles from './successful-sign-up.module.scss';

export const SuccessfulSignUp = () => (
  <Row>
    <Col className={styles['successful-sign-up']}>
      <div className={styles['icon-circle']} data-testid="mail-icon">
        <MailIcon aria-hidden />
      </div>
      <div className={styles['titles']}>
        <p className={`header ${styles['title']}`} data-testid="header">
          Check your inbox!
        </p>
        <p className={styles['subheader']} data-testid="subheader">
          Thanks for signing up.
        </p>
      </div>
      <p className={styles['description']} data-testid="description">
        Our team (and our servers) are hard at work setting up your company
        space. We’ll email you a secure link to activate your workspace the
        moment it’s ready.
      </p>
    </Col>
  </Row>
);
